import EventHandler from '../EventHandler';
function Disclosure_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function Disclosure_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Disclosure_createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        Disclosure_defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        Disclosure_defineProperties(Constructor, staticProps);
    return Constructor;
}
var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]',
};
var classes = {
    listVisible: 'disclosure-list--visible',
    alternateDrop: 'disclosure-list--alternate-drop',
};
class Disclosure {
    constructor(el) {
        Disclosure_classCallCheck(this, Disclosure);
        this.el = el;
        this.events = new EventHandler();
        this.cache = {};
        this._cacheSelectors();
        this._connectOptions();
        this._connectToggle();
        this._onFocusOut();
    }
}
Disclosure_createClass(Disclosure, [
    {
        key: '_cacheSelectors',
        value: function _cacheSelectors() {
            this.cache = {
                disclosureList: this.el.querySelector(selectors.disclosureList),
                disclosureToggle: this.el.querySelector(selectors.disclosureToggle),
                disclosureInput: this.el.querySelector(selectors.disclosureInput),
                disclosureOptions: this.el.querySelectorAll(selectors.disclosureOptions),
            };
        },
    },
    {
        key: '_connectToggle',
        value: function _connectToggle() {
            var _this = this;
            this.events.register(this.cache.disclosureToggle, 'click', function (e) {
                var ariaExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
                e.currentTarget.setAttribute('aria-expanded', !ariaExpanded);
                _this.cache.disclosureList.classList.remove(classes.alternateDrop);
                _this.cache.disclosureList.classList.toggle(classes.listVisible);
                window.requestAnimationFrame(function () {
                    var _this$cache$disclosur = _this.cache.disclosureList.getBoundingClientRect(), left = _this$cache$disclosur.left, width = _this$cache$disclosur.width;
                    var _window = window, innerWidth = _window.innerWidth;
                    var gutter = 30;
                    if (left + width + gutter > innerWidth) {
                        _this.cache.disclosureList.classList.add(classes.alternateDrop);
                    }
                });
            });
        },
    },
    {
        key: '_connectOptions',
        value: function _connectOptions() {
            var _this2 = this;
            var options = this.cache.disclosureOptions;
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                this.events.register(option, 'click', function (e) {
                    return _this2._submitForm(e.currentTarget.dataset.value);
                });
            }
        },
    },
    {
        key: '_onFocusOut',
        value: function _onFocusOut() {
            var _this3 = this;
            this.events.register(this.cache.disclosureToggle, 'focusout', function (e) {
                var disclosureLostFocus = !_this3.el.contains(e.relatedTarget);
                if (disclosureLostFocus) {
                    _this3._hideList();
                }
            });
            this.events.register(this.cache.disclosureList, 'focusout', function (e) {
                var childInFocus = e.currentTarget.contains(e.relatedTarget);
                var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);
                if (isVisible && !childInFocus) {
                    _this3._hideList();
                }
            });
            this.events.register(this.el, 'keyup', function (e) {
                if (e.defaultPrevented) {
                    return; // Do nothing if the event was already processed
                }
                if (e.key !== 'Escape' || e.key !== 'Esc')
                    return;
                _this3._hideList();
                _this3.cache.disclosureToggle.focus();
            });
            this.events.register(document.body, 'click', function (e) {
                var isOption = _this3.el.contains(e.target);
                var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);
                if (isVisible && !isOption) {
                    _this3._hideList();
                }
            });
        },
    },
    {
        key: '_submitForm',
        value: function _submitForm(value) {
            this.cache.disclosureInput.value = value;
            this.el.closest('form').submit();
        },
    },
    {
        key: '_hideList',
        value: function _hideList() {
            this.cache.disclosureList.classList.remove(classes.listVisible);
            this.cache.disclosureToggle.setAttribute('aria-expanded', false);
        },
    },
    {
        key: 'unload',
        value: function unload() {
            this.events.unregisterAll();
        },
    },
]);
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function closest(s) {
        var el = this;
        do {
            if (el.matches(s))
                return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
export { Disclosure };
